import Footer from "../../components/footer";
import React, { useState } from "react";
import "./resetPasswordEmail.css";
import { useNavigate } from "react-router-dom";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import InputField from "../../components/input/inputField";

const ResetPasswordEmail = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) return;
    navigate("/grow/reset-request", { state: { email } });
    // TODO: Implement your sign-in logic here
    console.log("Email submitted:", email);
  };
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SignupToolbar />
      <div className="reset-email-container">
        <div className="reset-email-form-wrapper">
          <h2 className="reset-email-heading">Enter your email</h2>
          <h3 className="reset-email-subtitle">
            We'll email you a link to reset your password.
          </h3>
          <InputField
            name="email"
            title="Email"
            placeholder="Enter email address"
            isRequired={true}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="submit"
            onClick={handleSubmit}
            className="reset-email-button"
            disabled={!isValidEmail(email)}
          >
            Continue
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPasswordEmail;
